import SectionHeading from '../ui/SectionHeading';
import Reveal from '../ui/Reveal';

const STEPS = [
  {
    title: 'Create an account',
    description: 'As an individual, or set up an organization account if you\'re bringing AI to a team.',
  },
  {
    title: 'Choose your plan',
    description: 'Start on a base plan for everyday text chat, or go Advanced to unlock document analysis, image generation, and API access.',
  },
  {
    title: 'Start chatting',
    description: 'Every message is automatically screened for sensitive information before it reaches the AI model — no extra steps.',
  },
  {
    title: 'Invite your team',
    description: 'Organizations only — add colleagues by email, assign roles, and manage access as your team changes.',
  },
  {
    title: 'Stay in control',
    description: 'Review your privacy and usage history any time, manage active sessions, and adjust your plan as your needs change.',
  },
];

export default function HowItWorksSection() {
  return (
    <section className="bg-surface py-24 dark:bg-midnight-800">
      <div className="container-page flex flex-col items-center gap-14">
        <SectionHeading eyebrow="Getting started" title="From sign-up to your first private conversation" />

        <div className="grid w-full grid-cols-1 gap-6 md:grid-cols-5">
          {STEPS.map((step, index) => (
            <Reveal key={step.title} delay={index * 0.08} className="relative flex flex-col gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-gradient text-sm font-bold text-white">
                {index + 1}
              </div>
              {index < STEPS.length - 1 && (
                <span className="absolute left-5 top-10 hidden h-[2px] w-full -translate-y-1/2 bg-line dark:bg-midnight-600 md:block" />
              )}
              <h3 className="text-sm font-bold text-ink dark:text-white">{step.title}</h3>
              <p className="text-sm leading-relaxed text-muted dark:text-subtle">{step.description}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
